module.exports = __webpack_public_path__ + "static/media/distancelearning.ab00ac10.png";